import { useEffect } from "react";

import { ReactionType, VoteType } from "components/server-types";
import { useKeyPress } from "mds/hooks/use-keyboard";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentClassUserIsInPersonClass } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { useAv } from "utils/av";
import { useClassActions } from "utils/class-utils";
import { isMacOS } from "utils/keyboard";

const POSSIBLE_KEYS = [
  // SIGNALS
  "y",
  "n",
  "h",
];

const POSSIBLE_SHIFT_KEYS = [
  // REACTIONS
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
];

const REACTION_KEYS_MAP: Record<string, ReactionType> = {
  "1": "like",
  "2": "dislike",
  "3": "agree",
  "4": "disagree",
  "5": "laugh",
  "6": "wow",
  "7": "love",
  "8": "clap",
};

const VOTE_KEYS_MAP: Record<string, VoteType> = {
  y: "yes",
  n: "no",
};

export const KeyboardShortcutsController = () => {
  const dispatch = useAppDispatch();
  const isInInPersonClass = useAppSelector(selectCurrentClassUserIsInPersonClass);
  const { isInVirtualClass, toggleHand } = useAv();
  const { toggleReaction, toggleVote } = useClassActions();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isModKeyPressed = isMacOS ? event.metaKey : event.ctrlKey;
      const isOtherModKeyPressed = isMacOS ? event.ctrlKey : event.metaKey;

      if (
        isModKeyPressed &&
        !isOtherModKeyPressed &&
        !event.altKey &&
        !event.shiftKey &&
        event.key.toLowerCase() === "k"
      ) {
        event.preventDefault();
        dispatch(viewStateActions.setKeyboardShortcutsDialogOpen(true));
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [dispatch]);

  useKeyPress({
    keys: POSSIBLE_KEYS,
    shiftKeys: POSSIBLE_SHIFT_KEYS,
    disabled: !isInInPersonClass && !isInVirtualClass,
    callback: (key) => {
      if (Object.keys(VOTE_KEYS_MAP).includes(key)) {
        toggleVote(VOTE_KEYS_MAP[key]);
      } else if (key === "h" && isInVirtualClass) {
        toggleHand();
      }
    },
    shiftCallback: (key) => {
      if (Object.keys(REACTION_KEYS_MAP).includes(key)) {
        toggleReaction(REACTION_KEYS_MAP[key]);
      }
    },
  });

  return null;
};
